import React, { Component } from 'react';

import IconButton from '../IconButton/IconButton';

import classes from './NotificationFilterSectionNew.module.css';

import filterIconBlue from '../../../assets/icons/filter-icon-blue.png';

class NotificationFilterSectionNew extends Component {

    state = {
        showFilterList: false
    }

    onFilterIconClick = () => {
        let updatedFilterState = !this.state.showFilterList;
        this.setState({ showFilterList: updatedFilterState });
    }

    categoryItemClick = (pos, id) => {
        this.setState({ showFilterList: false });
        this.props.onCategoryItemClick(pos, id);
    }

    render() {
        // console.log('Filter Props: ', this.props);
        const filterItems = this.props.filterCategories.map((item, pos) => {
            return <div key={pos}
                className={[classes.CategoryItem, parseInt(this.props.activeItemPos) === pos ? classes.Active : null].join(' ')}
                onClick={() => this.categoryItemClick(pos, item.id)}>
                {item.label}
                {
                    this.props.notificationsDropDown === true
                        ? <span className={classes.Count}>{item.count}</span>
                        : null
                }
            </div>
        });

        return (
            <div className={classes.FilterSection}>
                {/* <div className={classes.FilterIconContainer}>
                    <div className={classes.FilterIcon}>
                        <img alt="Filter Icon" src={filterIconBlue} />
                    </div>
                    <p className={classes.FilterText}>Filter by {this.props.filterBy ? this.props.filterBy : "Type"}</p>
                </div>
                <div className={classes.FilterIconContainerMobile} onClick={this.onFilterIconClick}>
                    <div>
                        <p>Type: {this.props.activeCategoryLabel} </p>
                    </div>
                    <IconButton
                        styleclass="NoBorder"
                        icon={filterIconBlue}
                        altText="Filter Icon Mobile"
                        padding="12px 0px"
                        margin="0px"

                    />
                </div> */}



                {this.state.showFilterList ?
                    <div className={classes.CategoryListMobile}>
                        {filterItems}
                    </div> : null}

                <div className={this.props.notificationsDropDown === true ? classes.CategoryListDropDown : classes.CategoryList}>
                    {filterItems}
                </div>
            </div>
        );
    }

}

export default NotificationFilterSectionNew;